/**
 * Helpers de gestion d'intervalle de date pour les filtres reporting.
 *
 *  - Par défaut, on couvre les 30 derniers jours, en générant des chaînes
 *    "YYYY-MM-DD" compatibles avec un `<input type="date">`.
 *  - Les helpers `toIsoFromDate`/`toIsoToDate` ajoutent la composante horaire
 *    pour cibler la journée complète au format ISO 8601 attendu par le backend.
 */

export function defaultDateRange(): { from: string; to: string } {
  const now = new Date();
  const fromDate = new Date(now.getTime() - 30 * 86_400_000);
  return {
    from: toYmd(fromDate),
    to: toYmd(now),
  };
}

export function toYmd(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Convertit "YYYY-MM-DD" en ISO 8601 début de journée (00:00:00 locale). */
export function toIsoFromDate(ymd: string): string | null {
  if (!ymd) return null;
  const d = new Date(`${ymd}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/** Convertit "YYYY-MM-DD" en ISO 8601 fin de journée (23:59:59 locale). */
export function toIsoToDate(ymd: string): string | null {
  if (!ymd) return null;
  const d = new Date(`${ymd}T23:59:59`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}
